import { ComponentClass } from 'react';
export { ComponentClass };

import ComposeViewState from 'owa-mail-compose-store/lib/store/schema/ComposeViewState';
import { ComposeCommandingBarProps } from './components/ComposeCommandingBar';
import { ComposeProps } from './components/Compose';
import { ComposeTabProps } from './components/ComposeTab';
import { DockProps } from './components/Dock';
import { FullComposeProps } from './components/FullCompose';
import { InitialActions } from 'owa-initial-actions';
import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailCompose" */ './lazyIndex')
);

// Delay loaded components
export let FullCompose = createLazyComponent(lazyModule, m => m.FullCompose);
export let Compose = createLazyComponent(lazyModule, m => m.Compose);
export let Dock = createLazyComponent(lazyModule, m => m.Dock);
export let ComposeCommandingBar = createLazyComponent(lazyModule, m => m.ComposeCommandingBar);

export let ComposeTab = createLazyComponent(lazyModule, m => m.ComposeTab);

// export synchronous interfaces
export {
    InitialActions,
    ComposeViewState,
    ComposeCommandingBarProps,
    ComposeProps,
    ComposeTabProps,
    DockProps,
    FullComposeProps,
};
